var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "userWizard" },
    [
      !_vm.upgradeComplete
        ? _c("div", { staticClass: "panel panel-plain" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "panel-body cwp splash-container-op",
                staticStyle: { "min-height": "40vh" }
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-xs-12" }, [
                    _vm.forceNewPassword
                      ? _c("h4", [_vm._v("Update Username and Password")])
                      : _c("h4", [
                          _vm._v("Click complete to finish the upgrade.")
                        ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _vm.pageInitted
                    ? _c("form", [
                        _c(
                          "div",
                          {
                            staticClass: "col-xs-12",
                            staticStyle: {
                              "min-height": "58px",
                              "margin-bottom": "5px"
                            }
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "col-xs-12",
                                attrs: { for: "j_username" }
                              },
                              [_vm._v("\n\t\t\t\t\t\t\tUsername\n\t\t\t\t\t\t")]
                            ),
                            _vm._v(" "),
                            !_vm.keepUserIdIfCan ||
                            !(
                              _vm.newUserName.toString() ===
                                _vm.userID.toString() &&
                              !!_vm.usernameResp.status &&
                              _vm.usernameResp.status === "OK"
                            )
                              ? _c("div", { staticClass: "col-xs-12" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.newUserName,
                                        expression: "newUserName"
                                      }
                                    ],
                                    staticClass: "form-control username",
                                    attrs: {
                                      name: "j_username",
                                      autocomplete: "off",
                                      maxlength: "40"
                                    },
                                    domProps: { value: _vm.newUserName },
                                    on: {
                                      keyup: function($event) {
                                        return _vm.searchTimeOut()
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.newUserName = $event.target.value
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.newUserName.toString().length === 0
                                    ? _c(
                                        "p",
                                        {
                                          staticClass: "help-block text-danger"
                                        },
                                        [_vm._v("*Username is required")]
                                      )
                                    : !!_vm.usernameResp.message
                                    ? _c(
                                        "p",
                                        {
                                          class: {
                                            "help-block": true,
                                            "text-success":
                                              _vm.usernameResp.status === "OK",
                                            "text-danger":
                                              _vm.usernameResp.status !== "OK"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "*" +
                                              _vm._s(_vm.usernameResp.message)
                                          )
                                        ]
                                      )
                                    : _c(
                                        "p",
                                        { staticClass: "help-block" },
                                        [
                                          _c("font-awesome-icon", {
                                            attrs: { icon: "spinner", spin: "" }
                                          })
                                        ],
                                        1
                                      )
                                ])
                              : _c("div", { staticClass: "col-xs-12" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.newUserName,
                                        expression: "newUserName"
                                      }
                                    ],
                                    staticClass: "form-control username",
                                    attrs: {
                                      name: "j_username",
                                      autocomplete: "off",
                                      maxlength: "40",
                                      readonly: "",
                                      disabled: ""
                                    },
                                    domProps: { value: _vm.newUserName },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.newUserName = $event.target.value
                                      }
                                    }
                                  })
                                ]),
                            _vm._v(" "),
                            _vm.forceNewPassword
                              ? [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "col-xs-12",
                                      attrs: { for: "j_password" }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\tNew Password\n\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-12" },
                                    [
                                      _c("password", {
                                        attrs: {
                                          toggle: true,
                                          secureLength: _vm.passwordMinLegth,
                                          showStrengthMeter: true,
                                          name: "j_password",
                                          autocomplete: "new-password",
                                          maxlength: "40"
                                        },
                                        model: {
                                          value: _vm.newPassword,
                                          callback: function($$v) {
                                            _vm.newPassword = $$v
                                          },
                                          expression: "newPassword"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "col-xs-12",
                                      attrs: { for: "j_password2" }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\tConfirm New Password\n\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-12" },
                                    [
                                      _c("password", {
                                        attrs: {
                                          toggle: true,
                                          secureLength: _vm.passwordMinLegth,
                                          showStrengthMeter: true,
                                          name: "j_password2",
                                          autocomplete: "new-password",
                                          maxlength: "40"
                                        },
                                        model: {
                                          value: _vm.newPasswordMatch,
                                          callback: function($$v) {
                                            _vm.newPasswordMatch = $$v
                                          },
                                          expression: "newPasswordMatch"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.passwordMessage > 0
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "help-block text-danger"
                                            },
                                            [
                                              _vm.passwordMessage === 1
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\tPassword must must have the following characteristics: \n\t\t\t\t\t\t\t\t\t\t"
                                                    ),
                                                    _c("ul", [
                                                      _c("li", [
                                                        _vm._v(
                                                          "At least " +
                                                            _vm._s(
                                                              _vm.passwordMinLegth
                                                            ) +
                                                            " characters - the more characters, the better."
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("li", [
                                                        _vm._v(
                                                          "A mixture of letters and numbers."
                                                        )
                                                      ])
                                                    ])
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.passwordMessage === 2
                                                ? _c("span", [
                                                    _vm._v(
                                                      "Confirm password does not match"
                                                    )
                                                  ])
                                                : _vm._e()
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              : _c("div")
                          ],
                          2
                        )
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "panel-footer container-fluid" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary next pull-right",
                  attrs: {
                    type: "button",
                    disabled: !_vm.formReady || _vm.clicked
                  },
                  on: { click: _vm.isCWPPasswordUsed }
                },
                [_vm._v(" \n\t\t\t\tComplete\n\t\t\t")]
              )
            ])
          ])
        : _c(
            "div",
            { staticClass: "text-center" },
            [
              _c("h1", [_vm._v("Upgrade Complete")]),
              _vm._v(" "),
              _c("fireworks", {
                attrs: { boxHeight: "100%", boxWidth: "100%" }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("You will be redirected to the home screen.")])
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            "modal-title": "Portal Alert!",
            show: _vm.showModal,
            "dialog-size": "sm",
            name: "passwordModal"
          },
          on: {
            close: function($event) {
              return _vm.closeModal()
            }
          }
        },
        [
          [
            _c("p", { staticClass: "text-center text-muted" }, [
              _vm._v("\n\t\t\t\t" + _vm._s(_vm.ModalText) + "\n\t\t\t")
            ])
          ],
          _vm._v(" "),
          _c("template", { slot: "footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-transparent pull-right",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.closeModal()
                  }
                }
              },
              [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(_vm.$t("MAIN_CONTENT.commonContent.closeButton")) +
                    "\n\t\t\t"
                )
              ]
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("h2", { staticClass: "panel-title" }, [
        _vm._v(
          "\n\t\t\t\tComplete the following entries to finalize your account upgrade.\n\t\t\t"
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }